import categoryApi from '@/api/category';

const SET_CATEGORIES = 'SET_CATEGORIES';
const DELETE_CATEGORY = 'DELETE_CATEGORY';
const ADD_CATEGORY = 'ADD_CATEGORY';
const UPDATE_CATEGORY = 'UPDATE_CATEGORY';

const state = {
  categories: []
};

const getters = {
  getCategories: state => {
    return state.categories;
  }
};

const mutations = {
  [SET_CATEGORIES] (state, categories) {
    state.categories = categories;
  },
  [DELETE_CATEGORY] (state, id) {
    const index = state.categories.map(e => e.id).indexOf(id);
    state.categories.splice(index, 1);
  },
  [ADD_CATEGORY] (state, category) {
    state.categories.push(category);
  },
  [UPDATE_CATEGORY] (state, category) {
    const index = state.categories.map(e => e.id).indexOf(category.id);
    state.categories.splice(index, 1, category);
  }
};

const actions = {
  retrieveCategories ({state, commit}, {context}) {
    return new Promise((resolve, reject) => {
      categoryApi.getCategories(context).then(data => {
        commit(SET_CATEGORIES, data);
        resolve();
      }, error => {
        reject(error);
      });
    });
  },
  deleteCategory ({state, commit}, {context, id}) {
    return new Promise((resolve, reject) => {
      categoryApi.deleteCategory(context, id).then(() => {
        commit(DELETE_CATEGORY, id);
        resolve();
      }, error => {
        reject(error);
      });
    });
  },
  createCategory ({commit}, {context, category}) {
    return new Promise((resolve, reject) => {
      categoryApi.createCategory(context, category)
        .then(data => {
          commit(ADD_CATEGORY, data);
          resolve();
        }, error => {
          reject(error);
        });
    });
  },
  updateCategory ({commit}, {context, category}) {
    return new Promise((resolve, reject) => {
      categoryApi.updateCategory(context, category)
        .then(data => {
          commit(UPDATE_CATEGORY, data);
          resolve();
        }, error => {
          reject(error);
        });
    });
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/category/index.js